<script setup lang="ts">
defineOptions({
  name: 'DoubleLeftIcon',
});
</script>

<template>
  <svg
    class="DoubleLeftIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.125 17.65L5.47498 12L11.125 6.34998L12.175 7.39998L7.59998 12L12.175 16.6L11.125 17.65ZM17.475 17.65L11.825 12L17.475 6.34998L18.525 7.39998L13.95 12L18.525 16.6L17.475 17.65Z"
    />
  </svg>
</template>

<style lang="scss" scoped>
.DoubleLeftIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
